import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import HomePage from "./Pages/HomePage/HomePage";
import AboutPage from "./Pages/AboutPage/AboutPage";
import ServicesPage from "./Pages/ServicesPage/ServicesPage";
import VerificationsAdmin from "./Pages/VerificationsAdmin/VerificationsAdmin";
import LegislationPage from "./Pages/LegislationPage/LegislationPage";
import PressRoomPage from "./Pages/PressRoomPage/PressRoomPage";
import OpportunitiesPage from "./Pages/OpportunitiesPage/OpportunitiesPage";
import ContactUsPage from "./Pages/ContactUsPage/ContactUsPage";
import WelfarePage from "./Pages/WelfarePage/WelfarePage";
import SearchResults from "./SearchResults";
import TendersPage from "./Pages/TendersPage/TendersPage";
import SAMSA1102025 from "./Pages/TendersPage/Tenders/SAMSA1102025";
import { FileProvider } from "./Contexts/FileContext"; 

function App() {
  return ( 
    <FileProvider>
      <Router>
      <div className="wrapper">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage/>}/>
            <Route path="/welfare" element={<WelfarePage/>}/>
            <Route path="/legislation" element={<LegislationPage/>}/>
            <Route path="/press-room" element={<PressRoomPage/>}/>
            <Route path="/opportunities" element={<OpportunitiesPage/>}/>
            <Route path="/contact-us" element={<ContactUsPage/>}/>
            <Route path="/search" element={<SearchResults />} />
            <Route path="/tenders" element={<TendersPage/>} />
            <Route path="/SAMSA1102025" element={<SAMSA1102025/>} />
            <Route path="/VerificationsAdmin" element={<VerificationsAdmin/>} />
            
            
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
    </FileProvider>
  );
}

export default App;
